/**
 * Created by idea on 14/04/2017.
 */
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import {HttpClient, HttpEvent} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import { HttpEventType } from '@angular/common/http';
import {Headers, Http} from '@angular/http';
import {Router} from '@angular/router';
import * as FileSaver from 'file-saver';

declare var $: any;
@Injectable()
export class DownloadService {
  private header: Headers;

  responseData: any;
  handleError: any;
  constructor(private http: Http, private router: Router) {
    let contentHeaders = new Headers();
    this.header = contentHeaders;
  }


  /**
   * download file with report progress and save dialog.
   *
   * @param url
   * @param fileName
   *
   * @return Observable contains progress by percent
   *
   */
  downloadFile(url: string, fileName: string)  {
        this.requestDownload(url, fileName).subscribe(data => {
            this.saveDownloadResult(data.data.file, data.data.type, fileName)
        });
  }

  private saveDownloadResult(blob: Blob, fileType, fileName) {
      // var windowURL = window.URL || window['webkitURL'];
      // const downloadLink = document.createElement('a');
      // const urlBlob = windowURL.createObjectURL(new Blob([blob]));
      // downloadLink.href = urlBlob;
      // downloadLink.download = fileName;
      // downloadLink.click();
      // setTimeout(function () { URL.revokeObjectURL(downloadLink.href) }, 404);
    const data: Blob = new Blob([blob], {type: fileType});
    FileSaver.saveAs(data, fileName);
  }

  private requestDownload(url: string, fileName: string): Observable<any> {

    if (localStorage.getItem('Access-Token')) {
      this.header.set('authorization', localStorage.getItem('Access-Token'));
    }
    return this.http.get( environment.api_evs + '/download/' + fileName, {headers: this.header})
      .map((res: any) => {
        return res.json();
      })
      .catch((error: any) => {
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/common/services/Download.service.ts